import { Box, Paper, Typography } from '@mui/material';
import ListTitleBox from './list/ListTitleBox';

interface Props {
  title?: string;
  emptyText: string;
  onPrimaryClick?: () => void;
  onBackClick?: () => void;
}

export default function EmptyScreen({
  title,
  emptyText,
  onPrimaryClick,
  onBackClick = undefined,
}: Props) {
  return (
    <Box>
      {title && (
        <ListTitleBox
          title={title}
          onPrimaryClick={onPrimaryClick}
          onBackClick={onBackClick}
        />
      )}
      <Paper
        sx={{
          p: 4,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 200,
        }}
      >
        <Typography variant="h6" color="text.secondary">
          {emptyText}
        </Typography>
      </Paper>
    </Box>
  );
}
